<template>
  <qx-card-form title="车辆图片" v-show="showComponent" :defaultContentShow="false">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px"></qx-custom-form>
    <button @click="getDataTest" class="test-btn">测试提交参数</button>
  </qx-card-form>
</template>

<script>
import {
  getFileUrl,
} from 'api';

const aImgName = ['carRegistrationPictureList', 'vehiclePictureList'];
export default {
  data () {
    return {
      showComponent: true,
      baseForm: {
        inline: true,
        form: [
          {
            label: '车辆登记证书图片',
            value: 'carRegistrationPictureList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 2,
            },
            default: [],
            hide: false,
          },
          {
            label: '车辆图片',
            value: 'vehiclePictureList',
            type: 'img',
            accept: 'image/*',
            fileSize: 51200000000,
            attr: {
              limit: 1,
            },
            default: [],
            hide: false,
          },
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    async getDataTest () {
      this.sub();
    },
    // 修改车辆种类为【临时外调车时】
    changeToOutward () {
      // 切换成临时外调车
      this.setBaseForm('outward');
    },
    resetToNormal () {
      // 恢复成正常模式
      this.setBaseForm('my');
    },
    setBaseForm (mode) {
      if (mode === 'my') {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: false,
          names: [
            'vehiclePictureList',
          ],
        });
        this.showComponent = true;
      } else {
        this.setFormAttrVal({
          form: this.baseForm,
          attr: 'hide',
          value: true,
          names: ['vehiclePictureList'],
        });
        this.showComponent = false;
      }
    },
    // 设置所有表单
    resetBaseForm () {
      if (this.$route.query.type === 'my') {
        this.setBaseForm('my');
      } else {
        this.setBaseForm('outward');
      }
    },
    // 统一处理数据格式
    async handleSubData (cache) {
      let formData;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
      } else {
        formData = await this.$refs.baseForm.sub();
      }
      if (formData || cache) {
        // 讲需要提交的图片字段放进 formData 对象里面
        for (let imgItem of aImgName) {
          // 获取要提交的字段名，例如这里是将 drivingLicenseList 截取成 drivingLicense
          let imgField;
          if (imgItem === 'vehiclePictureList') {
            imgField = imgItem.substring(imgItem.indexOf('tureList'), 0);
          } else {
            imgField = imgItem.substring(imgItem.indexOf('List'), 0);
          }
          // 如果 drivingLicenseList 数组里面有图片，则将数组里面的图片id 赋值给 drivingLicense，用于提交和缓存数据
          if (formData[imgItem] && formData[imgItem].length) {
            if (imgItem === 'vehiclePictureList') {
              formData.vehiclePicture = formData[imgItem][0].id;
              formData[imgField + 'Url'] = formData[imgItem][0].url;


            } else {

              formData[imgField] = formData[imgItem][0].id;
              formData[imgField + 'Url'] = formData[imgItem][0].url;

              if (formData.carRegistrationPictureList && formData.carRegistrationPictureList.length) {
                let imgIds = [];
                let imgUrls = [];
                formData.carRegistrationPictureList.forEach((item) => {
                  imgIds.push(item.id);
                  imgUrls.push(item.url);
                });
                formData.carRegistrationPicture = imgIds.join(',');
                formData.carRegistrationPictureUrl = imgUrls.join(',');
              }
            }
          } else {
            imgItem === 'vehiclePictureList' ? formData.vehiclePicture = '' : formData[imgField] = '';
            formData[imgField + 'Url'] = '';
          }
        }
        if (this.$route.query.type === 'outward') {
          formData = {};
        }
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      let formData = await this.handleSubData();
      // 新建的情况下,如果使用了OCR识别，要对比和输入的车牌号是否一致，如果不一致 autoAudit = 0，否则为 1
      if (formData) {
        delete formData.carRegistrationPictureList;
        delete formData.vehiclePictureList;
      }
      return formData;
    },
    async init (data = {}) {

      // 重置表单
      this.resetBaseForm();

      this.$refs.baseForm.reset();

      let flowIds = [];
      for (let imgItem of aImgName) {
        // 获取详情接口返回的的字段名，例如这里是将 drivingLicenseList 截取成 drivingLicense
        const imgField = imgItem.substring(imgItem.indexOf('List'), 0);
        // 例如 drivingLicense 有图片id值，代表有图片，传图片id到另外一个接口获取图片url
        if (data[imgField]) {
          flowIds.push(data[imgField]);
        } else {
          // 如果没有数据，则设置为空数组，防止报错
          data[imgItem] = [];
        }
      }
      if (flowIds.length) {
        const imgRes = await getFileUrl({
          flowIds: flowIds.join(),
        });
        for (let imgItem of aImgName) {
          let imgField;
          if (imgItem === 'vehiclePictureList') {
            imgField = imgItem.substring(imgItem.indexOf('tureList'), 0);
          } else {
            imgField = imgItem.substring(imgItem.indexOf('List'), 0);
          }
          let files = [];
          imgRes.items.forEach((item) => {
            if (`${item.flowId}` === `${data[imgField]}`) {
              if (data[imgField]) {
                data[imgItem + 'Url'] = item.fullPath;
                data[imgItem] = [{
                  id: `${item.flowId}`,
                  url: item.fullPath,
                }];
              }
            }
            if (`${item.flowId}` === `${data.vehiclePicture}`) {
              data[imgItem + 'Url'] = item.fullPath;
              data.vehiclePictureList = [{
                id: `${item.flowId}`,
                url: item.fullPath,
              }];
            }
            if (data.carRegistrationPicture) {
              data.carRegistrationPicture.split(',').forEach((itemFlowId) => {
                if (`${item.flowId}` === itemFlowId) {
                  files.push({
                    id: `${item.flowId}`,
                    url: item.fullPath,
                  });
                }
              });
              data.carRegistrationPictureList = files;
            }
          });
        }
      }

      this.$refs.baseForm.setVal(data);
    },
    formChange (vehicleInfo) {
      this.resetBaseForm();
    },
    receivedData (vehicleInfo) {
      this.formChange(vehicleInfo);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
